import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useShellContext } from '../shell/context.js';
import { PanneauDemander } from './PanneauDemander.js';
import styles from './DemanderPage.module.css';

/** « Demander » en pleine page : la même surface que l'onglet ⌘K, atteignable sans clavier. */
export function DemanderPage(): JSX.Element {
  const { t } = useTranslation('regie');
  const { compte, galerie, galerieSlug } = useShellContext();
  return (
    <div className={styles.page} data-ui="demander">
      <header>
        <h1 className={styles.titre} data-ui="page-heading">
          {t('assistantRecherche.titre')}
        </h1>
        <p className={styles.sousTitre}>{t('assistantRecherche.sousTitre')}</p>
      </header>
      {/* Changer de compte ou de galerie efface l'échange. */}
      <PanneauDemander
        key={`${compte.id}:${galerieSlug}`}
        galerie={galerie}
        galerieSlug={galerieSlug}
        etendu
      />
    </div>
  );
}
